import { hasTranslation, translateOutsideReact } from '@/i18n/translateOutsideReact';

/** A `ServiceError.errorType`: a code, never a sentence. Anything else is not looked up (a key like `constructor`). */
const ERROR_TYPE_SHAPE = /^[A-Z][A-Z0-9_]*$/;

/**
 * The sentence for a backend refusal code in the language the app shows, or undefined when the
 * catalog has none, or null when it has one that cannot be filled in. The consultant app's own wording (`consultantErrors.codes`) wins over the
 * shared one (`errors.codes`, written for the client portal) where the two audiences differ.
 */
export function errorSentence(code: string, params?: Record<string, string | number>): string | undefined | null {
  if (!ERROR_TYPE_SHAPE.test(code)) return undefined;
  for (const namespace of ['consultantErrors', 'errors']) {
    const key = `${namespace}.codes.${code}`;
    if (hasTranslation(key)) {
      const text = translateOutsideReact(key, params);
      // A sentence that cannot be formatted (a parameter did not arrive) comes back as the key's own path.
      return text.endsWith(key) ? null : text;
    }
  }
  return undefined;
}
